module.exports = __webpack_public_path__ + "static/img/C (26).1bf6238b.png";